import React from 'react';

function TestComponent() {
  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center">
      <h1 className="text-4xl text-white font-bold">Test Component</h1>
    </div>
  );
}

export default TestComponent; 